import styled from 'styled-components';
import { Flex, FlexProps } from '../../layout/Flex';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'BusinessStatisticDisclaimer' })
    .attrs((props: FlexProps) => ({
        ...props,
        direction: 'row',
        spacing: 1,
        width: '100%',
        background: 'var(--background-secondary)',
        alignItems: 'center',
        p: 2,
        borderRadius: 3,
    }))``;
